module.exports = __webpack_public_path__ + "img/resized-cover2.a8f2f52f.png";